module.exports = __webpack_public_path__ + "img/icon-dropdown-light-gray.d171ac05.svg";